import React, { Component } from 'react'
import { Result, Button } from 'hljd'
import { HOME_PATH_A } from '@constant'

export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      seconds: 3
    }
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState(
        preState => ({
          seconds: preState.seconds - 1
        }),
        () => {
          if (this.state.seconds === 0) {
            clearInterval(this.timer)
          }
        }
      )
    }, 1000)
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  render() {
    const { seconds } = this.state

    if (seconds === 0) {
      window.location.href = HOME_PATH_A
    }

    return (
      <Result
        status="success"
        title="协议签署成功"
        subTitle={
          '您已同意婚礼纪限时团购活动合作协议 ，即将跳转回首页.' + seconds
        }
        extra={[
          <Button
            type="primary"
            key="console"
            onClick={() => {
              clearInterval(this.timer)
              window.location.href = HOME_PATH_A
            }}
          >
            返回首页
          </Button>
        ]}
      />
    )
  }
}
